module.exports = __webpack_public_path__ + "img/LEGAL-SAB.bef84442.svg";